import PATHS from '../constants';

function fetchServices() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.SERVICES, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchServices;